import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import defaultOpenGraphImage from "../images/open-graph-image.png"

function SEO({ description, lang, image, meta, keywords, title, pathname }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description

        const metaUrl = `${data.site.siteMetadata.siteUrl}${pathname}`

        const metaImage =
          image && image.src
            ? `${data.site.siteMetadata.siteUrl}${image.src}`
            : `${data.site.siteMetadata.siteUrl}${defaultOpenGraphImage}`

        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: `${title} | ${data.site.siteMetadata.title}`,
              },
              {
                property: `og:url`,
                content: metaUrl,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                property: `og:image`,
                content: metaImage,
              },
              {
                property: `og:image:alt`,
                content: title,
              },
              {
                property: "og:image:width",
                content: (image && image.width) || 1200,
              },
              {
                property: "og:image:height",
                content: (image && image.height) || 630,
              },
              {
                name: `x:card`,
                content: `summary_large_image`,
              },
              {
                name: `x:creator`,
                content: `@${data.site.siteMetadata.social.x}`,
              },
              {
                name: `x:title`,
                content: `${title} | ${data.site.siteMetadata.title}`,
              },
              {
                name: `x:description`,
                content: metaDescription,
              },
              {
                name: `google-site-verification`,
                content: `OazaLI0-7WA6esExF3N-qxjxTngSF7319eF141Pzy9o`,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          />
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
  pathname: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  image: PropTypes.object,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  pathname: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        siteUrl
        description
        author
        social {
          x
        }
      }
    }
  }
`
